import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import GooeyNav from './GooeyNav';
import './header.css';

const LOGO_SVG = `data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="160" height="28" viewBox="0 0 160 28"><text y="20" font-family="JetBrains Mono,monospace" font-size="14" fill="%23CCFF00" font-weight="700">doazhu.pro</text></svg>`;

const navItems = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Work', to: '/work' },
  { label: 'Contact', to: '/contact' },
];

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const activeIndex = Math.max(
    0,
    navItems.findIndex(item => item.to === location.pathname)
  );

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  // Lock body scroll when menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const handleNavClick = (to) => {
    setMenuOpen(false);
    navigate(to);
  };

  return (
    <>
      <header className="site-header">
        {/* Logo */}
        <a
          href="/"
          onClick={e => { e.preventDefault(); navigate('/'); }}
          className="site-header__logo cursor-target"
        >
          <img src={LOGO_SVG} alt="doazhu.pro" style={{ height: '28px', display: 'block' }} />
        </a>

        {/* Desktop nav */}
        <div className="site-header__nav">
          <GooeyNav
            items={navItems}
            initialActiveIndex={activeIndex}
            onNavigate={(item) => navigate(item.to)}
            particleCount={15}
            particleDistances={[90, 10]}
            particleR={100}
            animationTime={600}
            timeVariance={300}
            colors={[1, 2, 3, 1, 2, 3, 1, 4]}
          />
        </div>

        {/* Desktop CTA */}
        <a
          href="mailto:me@doazhu.pro"
          className="site-header__cta cursor-target"
        >
          Написать
        </a>

        {/* Burger button */}
        <button
          className={`site-header__burger${menuOpen ? ' is-open' : ''}`}
          onClick={() => setMenuOpen(v => !v)}
          aria-label="Меню"
        >
          <span />
          <span />
          <span />
        </button>
      </header>

      {/* Mobile menu overlay */}
      <div
        className={`mobile-menu${menuOpen ? ' is-open' : ''}`}
        onClick={() => setMenuOpen(false)}
      >
        <nav onClick={e => e.stopPropagation()}>
          <ul className="mobile-menu__list">
            {navItems.map((item) => (
              <li key={item.to}>
                <button
                  className={`mobile-menu__link${location.pathname === item.to ? ' is-active' : ''}`}
                  onClick={() => handleNavClick(item.to)}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
          <a
            href="mailto:me@doazhu.pro"
            className="mobile-menu__cta"
            onClick={() => setMenuOpen(false)}
          >
            Написать
          </a>
        </nav>
      </div>
    </>
  );
}

export default Header;
